import config from "../config";
import type { APIConfigType } from "./types";

const { baseApiURL } = config;

const flightBaseUrl = `${baseApiURL}flight/v1/`;
const flightBaseUrlV1o1 = `${baseApiURL}flight/v1.1/`;
const clientFlightBaseURL = "/api/flight/";

export const API_CONFIG = {
  airports: {
    client: `${clientFlightBaseURL}airports`,
    back: `${flightBaseUrl}airports`,
  },
  calendar: {
    client: `${clientFlightBaseURL}calendar`,
    back: `${flightBaseUrl}calendar`,
  },
  refundRules: {
    back: `${flightBaseUrl}cancel-rules`,
  },
  availability: `${flightBaseUrl}availability`,
  detail: `${flightBaseUrl}detail`,
  storePassengers: {
    client: `${clientFlightBaseURL}storePassengers`,
    back: `${flightBaseUrlV1o1}passenger/store`,
  },
  getPassengers: `${flightBaseUrlV1o1}passenger/`,
  check: {
    client: `${clientFlightBaseURL}check`,
    back: `${flightBaseUrl}check`,
  },
  book: {
    client: `${clientFlightBaseURL}book`,
    back: `${flightBaseUrl}order`,
  },
};

export const FLIGHT_API_CONFIG: APIConfigType<typeof API_CONFIG> = API_CONFIG;
